<template>
  <div class="contact-admin" v-if="currentUser">
    <div class="page-header">
      <h1>Edycja danych kontaktowych</h1>
    </div>

    <div class="layout">
      <div class="section-card">
        <div class="section-card-header">
          <h2>Aktualne dane</h2>
        </div>

        <div class="info-list">
          <div class="info-item">
            <div class="info-content">
              <span class="info-label">Adres 1</span>
              <span class="info-value">{{ address1 }}</span>
            </div>
            <button class="btn-icon" @click="editData('address1', 'adres 1')" title="Edytuj">
              <img src="@/assets/icons/pencil-square.svg" alt="Edytuj">
            </button>
          </div>

          <div class="info-item">
            <div class="info-content">
              <span class="info-label">Adres 2</span>
              <span class="info-value">{{ address2 }}</span>
            </div>
            <button class="btn-icon" @click="editData('address2', 'adres 2')" title="Edytuj">
              <img src="@/assets/icons/pencil-square.svg" alt="Edytuj">
            </button>
          </div>

          <div class="info-item">
            <div class="info-content">
              <span class="info-label">Numer telefonu</span>
              <span class="info-value">{{ phoneNum }}</span>
            </div>
            <button class="btn-icon" @click="editData('phoneNum', 'telefon')" title="Edytuj">
              <img src="@/assets/icons/pencil-square.svg" alt="Edytuj">
            </button>
          </div>

          <div class="info-item">
            <div class="info-content">
              <span class="info-label">Adres e-mail</span>
              <span class="info-value">{{ emailAddress }}</span>
            </div>
            <button class="btn-icon" @click="editData('emailAddress', 'adres e-mail')" title="Edytuj">
              <img src="@/assets/icons/pencil-square.svg" alt="Edytuj">
            </button>
          </div>

          <div class="info-item">
            <div class="info-content">
              <span class="info-label">NIP</span>
              <span class="info-value">{{ nip }}</span>
            </div>
            <button class="btn-icon" @click="editData('nip', 'nip')" title="Edytuj">
              <img src="@/assets/icons/pencil-square.svg" alt="Edytuj">
            </button>
          </div>
        </div>
      </div>

      <div class="section-card edit-card" v-if="isEditing">
        <div class="section-card-header">
          <h2>Edytuj: {{ whichKey }}</h2>
          <button class="btn-outline" @click="closeEdit">Zamknij</button>
        </div>

        <div class="form-group">
          <label for="editInput">Nowa wartość</label>
          <input
              type="text"
              id="editInput"
              v-model="editInput"
              placeholder="Wpisz nową wartość..."
          >
        </div>

        <div class="form-actions">
          <button class="btn-green" @click="postCtInfo">Zapisz zmiany</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authHeader from '@/services/auth-header';
import axios from 'axios';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'ContactInfoEdit',
  setup() {
    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      address1: 'brak',
      address2: 'brak',
      phoneNum: 'brak',
      emailAddress: 'brak',
      nip: 'brak',
      isEditing: false,
      whichKey: '',
      key: '',
      editInput: '',
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    },
  },
  mounted() {
    this.getCtInfo();
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 1) {
      this.$router.push('/login');
    }
  },
  methods: {
    getCtInfo() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}ContactGet`)
          .then(res => {
            this.address1 = res.data.address_1 || 'brak';
            this.address2 = res.data.address_2 || 'brak';
            this.phoneNum = res.data.phone || 'brak';
            this.emailAddress = res.data.email || 'brak';
            this.nip = res.data.nip || 'brak';
          });
    },
    editData(key, whk) {
      this.isEditing = true;
      this.whichKey = whk;
      this.key = key;
      this.editInput = this[key] && this[key] !== 'brak' ? this[key] : '';
      window.scrollTo(0, document.body.scrollHeight);
    },
    closeEdit() {
      this.isEditing = false;
      this.whichKey = '';
      this.key = '';
      this.editInput = '';
    },
    postCtInfo() {
      if (this.key === '' || this.editInput.trim() === '') {
        this.appStore.setIsAlert('Wpisz poprawną wartość');
        return;
      }

      this[this.key] = this.editInput.trim();

      const ob = {
        address_1: this.address1,
        address_2: this.address2,
        phone: this.phoneNum,
        email: this.emailAddress,
        nip: this.nip,
      };

      axios.post(`${process.env.VUE_APP_API_BASE_URL}Contact`, ob, authHeader())
          .then(res => {
            if (String(res.status).charAt(0) === '2') {
              this.appStore.setIsSuccess('Zapisano dane kontaktowe');
              this.closeEdit();
            }
          })
          .catch(() => {
            this.appStore.setIsAlert('Nie udało się zapisać danych kontaktowych');
          });
    },
  },
};
</script>

<style scoped>
.contact-admin {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  font-size: 2.8rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.layout {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
}

.section-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}

.section-card h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.info-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.info-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.info-item:hover {
  border-color: #10b981;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}

.info-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.info-label {
  font-size: 1.3rem;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  font-weight: 600;
}

.info-value {
  font-size: 1.6rem;
  font-weight: 600;
  color: #1f2937;
  word-break: break-word;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;
}

.form-group label {
  font-size: 1.5rem;
  font-weight: 600;
  color: #374151;
}

.form-group input {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 1.5rem;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
  width: 100%;
}

.form-group input:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.1);
}

.form-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.edit-card {
  border: 1px solid #10b981;
}

.btn-green {
  background-color: #10b981;
  color: #fff;
  padding: 10px 16px;
  border-radius: 8px;
  border: none;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-green:hover {
  background-color: #059669;
}

.btn-outline {
  background-color: transparent;
  color: #1f2937;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 1.5rem;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

.btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  transition: background-color 0.2s;
  flex-shrink: 0;
}

.btn-icon img {
  width: 20px;
  height: 20px;
}

.btn-icon:hover {
  background-color: #f3f4f6;
}

@media (max-width: 480px) {
  .contact-admin {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .section-card h2 {
    font-size: 1.8rem;
  }

  .btn-green,
  .btn-outline {
    width: 100%;
    text-align: center;
  }

  .section-card-header {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>